import { cn } from '../lib/cn.js'
import logoAdmin from '../assets/logo-admin.webp'
import logoStore from '../assets/logo-store.webp'
import logoStoreMark from '../assets/logo-store-mark.webp'

/**
 * شعار مكتبة النجاح — كتاب مفتوح ينهض منه قارئ.
 *
 * نسختان بحسب الجمهور:
 *  - `admin`: العلامة الذهبية وحدها، على بلاطة خضراء — الذهب والكريمي يضيعان
 *    على خلفية فاتحة بلا بلاطة، والبلاطة تُثبّت الهوية في الوضعين.
 *  - `store`: علامة الزبائن (أخضر + ذهبي) بلا نصّ؛ النصّ يأتي من `Logo` أو من الشاشة نفسها.
 *
 * الأصول webp مقصوصة من الملفّات الأصلية في apps/assets — لا تُعدَّل يدوياً.
 */
export type LogoVariant = 'admin' | 'store'

export function LogoMark({
  className,
  variant = 'admin',
}: { className?: string; variant?: LogoVariant }) {
  if (variant === 'store') {
    return (
      <img
        src={logoStoreMark}
        alt=""
        aria-hidden
        draggable={false}
        className={cn('size-8 select-none object-contain', className)}
      />
    )
  }

  return (
    // الصورة مُموضَعة مطلقاً بنسبة من البلاطة: `size-full` داخل grid ذي حشوة نسبية
    // ينهار إلى صفر لأن ارتفاع الخلية غير محدَّد — فتظهر البلاطة فارغة.
    <span
      aria-hidden
      className={cn('relative block size-8 shrink-0 rounded-[22%] bg-primary', className)}
    >
      <img
        src={logoAdmin}
        alt=""
        draggable={false}
        className="absolute inset-[12%] size-[76%] select-none object-contain"
      />
    </span>
  )
}

/** الشعار الكامل بالنصّ — للمتجر تُستعمل صورة الشعار الأصلية بخطّها، وللإدارة العلامة + الاسم. */
export function Logo({
  className,
  showTagline = false,
  variant = 'admin',
}: { className?: string; showTagline?: boolean; variant?: LogoVariant }) {
  if (variant === 'store') {
    return (
      <img
        src={logoStore}
        alt="مكتبة النجاح"
        draggable={false}
        className={cn('h-12 w-auto select-none object-contain', className)}
      />
    )
  }

  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <LogoMark />
      <div className="leading-tight">
        <p className="font-display text-[17px] font-bold tracking-tight text-fg">مكتبة النجاح</p>
        {showTagline && <p className="text-[11px] text-fg-subtle">نظام إدارة المكتبة والقرطاسية</p>}
      </div>
    </div>
  )
}
